import { useState, useEffect } from 'react'
import axios from 'axios'
import { Pagination, Spin, Image, Tooltip } from 'antd'
import AddEnthusiast from './add'
import EditEnthusiast from './edit'
import DeleteEnthusiast from './delete'
import EnthusiastRibbon from './ribbon'
import MyIcon from '../../components/general/icon'

export default function Enthusiast() {
  const [enthusiastData, setEnthusiastData] = useState({})
  const [propsData, setPropsData] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)
  const [isAddEnthusiastVisible, setIsAddEnthusiastVisible] = useState(false)
  const [isEditEnthusiastVisible, setIsEditEnthusiastVisible] = useState(false)
  const [isDeleteEnthusiastVisible, setIsDeleteEnthusiastVisible] = useState(false)

  const initialConditions = {
    keywords: '',
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getEnthusiastData = () => {
    axios.post('/admin/content/enthusiast/list/get', { 
      keywords: filterValue.keywords,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setIsLoading(false)
          setEnthusiastData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'enthusiasts': response.data.enthusiasts
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getEnthusiastData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue, currentPage])

  const editEnthusiast = (oid) => {
    setIsEditEnthusiastVisible(true)
    setPropsData({ oid: oid })
  }

  const deleteEnthusiast = (oid, title) => {
    setIsDeleteEnthusiastVisible(true)
    setPropsData({ oid: oid, title: title})
  }

  return (
    <div className="public-page">
      <Spin spinning={isLoading}>
        <div className="public-container">
          <div className="public-header">
            <div className="public-title">达人风采</div>
            <EnthusiastRibbon
              filterValue={filterValue} 
              setFilterValue={setFilterValue} 
              isAddVisible={() => { setIsAddEnthusiastVisible(true) }}  
            />
          </div>

          <div className='public-main-style'>
            <div className='public-main-style2'>
              <table className='public-main-style2-item'>
                <thead>
                  <tr className='public-main-style2-thead'>
                    <th style={{width: '300px'}}>
                      <div className='public-main-style2-title'>标题</div>
                    </th>
                    <th>排序</th>
                    <th style={{width: '50px'}}></th>
                  </tr>
                </thead>

                <tbody>
                  {enthusiastData.enthusiasts && (enthusiastData.enthusiasts.length > 0 ? (enthusiastData.enthusiasts.map((item) => (
                    <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { editEnthusiast(item.oid) }}>
                      <td style={{width: '300px'}}>
                        <div className='public-main-style2-tuwen'>
                          <div style={{margin: '10px 15px 10px 0'}} onClick={(event) => {event.stopPropagation()}}>
                            <Image src={item.photo_url} width={80} height={100} />
                          </div>
                          <span>{item.title}</span>
                        </div>
                      </td>
                      <td>{item.sort}</td>
                      <td style={{width: '50px'}}>
                        <div className='public-main-style2-operation-box'>
                          <Tooltip placement="bottom" color='#1A1B1C' title="删除">
                            <div className='public-main-style2-operation' 
                              onClick={(event) => {event.stopPropagation(); deleteEnthusiast(item.oid, item.title)}}>
                              <MyIcon name='huishouzhan' />
                            </div>
                          </Tooltip>
                        </div>
                      </td>
                    </tr>
                  ))) : (
                    <tr className='public-main-style2-tbodyEmpty'>
                      <td colSpan='4'><span>暂无数据</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className='pagination'>
              <Pagination 
                current={currentPage}
                total={enthusiastData.total}
                pageSize={20}
                onChange={(page) => setCurrentPage(page)}
                showTotal={(total) => `共${total}条`}
                showSizeChanger={false}
                hideOnSinglePage={true}
                showQuickJumper={true}
              />
            </div>
          </div>
        </div>

        {isAddEnthusiastVisible && <AddEnthusiast
          getEnthusiastData={getEnthusiastData} 
          isOpen={isAddEnthusiastVisible} 
          isCancel={() => { setIsAddEnthusiastVisible(false) }} 
        />}

        {isEditEnthusiastVisible && <EditEnthusiast
          data={propsData}
          getEnthusiastData={getEnthusiastData} 
          isOpen={isEditEnthusiastVisible} 
          isCancel={() => { setIsEditEnthusiastVisible(false) }} 
        />}

        {isDeleteEnthusiastVisible && <DeleteEnthusiast
          data={propsData}
          getEnthusiastData={getEnthusiastData} 
          isOpen={isDeleteEnthusiastVisible} 
          isCancel={() => { setIsDeleteEnthusiastVisible(false) }} 
        />}
      </Spin>
    </div>
  )
}
